var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hina-color-panel",style:({ backgroundColor: _vm.background })},[_c('div',{staticClass:"hina-color-panel__white"}),_c('div',{staticClass:"hina-color-panel__black"}),_c('div',{staticClass:"hina-color-panel__cursor",style:({ left: _vm.cursorLeft + 'px', top: _vm.cursorTop + 'px' })},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }